module.exports = __webpack_public_path__ + "static/media/residential-construction.e75089d1.jpg";